import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  CardProps,
  Flex,
  Icon,
  Skeleton,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiChevronRight } from "react-icons/fi";
import { Link as RouterLink } from "react-router";

export interface BreadcrumbInfo {
  name: string;
  toUrl: string;
}

export interface BreadCrumbCurrentPage {
  name: string;
}

interface BreadcrumbsProps extends CardProps {
  breadcrumbInfos: Array<BreadcrumbInfo | BreadCrumbCurrentPage>;
  isLoading?: boolean;
}

export default function CaminoBreadcrumbs({ breadcrumbInfos, isLoading = false, ...rest }: BreadcrumbsProps) {
  const color = useColorModeValue("content.tertiary", "fg.muted");
  return (
    <Skeleton isLoaded={!isLoading}>
      <Breadcrumb
        fontSize="xs"
        pb="4"
        spacing="1"
        separator={
          <Flex align="center">
            <Icon as={FiChevronRight} color={color} boxSize={4} />
          </Flex>
        }
        {...rest}
      >
        {breadcrumbInfos.map((breadcrumInfo, index) => {
          const toUrl = "toUrl" in breadcrumInfo ? breadcrumInfo.toUrl : undefined;
          return (
            <BreadcrumbItem key={`${breadcrumInfo.name}${index}`} isCurrentPage={!toUrl}>
              {!toUrl ? (
                <BreadcrumbLink color={color} fontWeight="600">
                  {breadcrumInfo.name}
                </BreadcrumbLink>
              ) : (
                <BreadcrumbLink color={color} fontWeight="600" as={RouterLink} to={toUrl}>
                  {breadcrumInfo.name}
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          );
        })}
      </Breadcrumb>
    </Skeleton>
  );
}
